export default "__VITE_ASSET__ClV5ZqAj__"